import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NavItem, NavItemsType} from '@pt/pt-models';
import {NgxPermissionsService} from 'ngx-permissions';

@Component({
  selector: 'pt-sidebar-item',
  templateUrl: './sidebar-item.component.html',
  styleUrls: ['./sidebar-item.component.scss']
})
export class SidebarItemComponent implements OnInit {

  @Input() item: NavItem;
  @Input() collapsed: boolean;
  @Input() itemMenuOpenedId: string;
  @Input() autoCloseMenuItem: boolean;
  @Input() selectionMode: 'border' | 'subMenu' = 'border';
  @Output() openMenu = new EventEmitter<NavItem>();

  T = NavItemsType;
  isEnabled = true;

  constructor(private permissionService: NgxPermissionsService) {
  }

  ngOnInit(): void {
    if (this.item.permissEnabled?.length > 0) {
      this.permissionService.hasPermission(this.item.permissEnabled).then((enabled) => {
        this.isEnabled = enabled;
      });
    } else {
      this.isEnabled = true;
    }
  }
}
